import { EquipmentMasterData } from './EquipmentMasterData'
import { IEquipmentMasterDataDTO } from './IEquipmentMasterDataDTO'
import { IEquipmentMasterDataWithBomWarningCount } from './IEquipmentMasterDataWithBomWarningCount'

/** Equipment data shown to admins */
export class AdminEquipmentRow extends EquipmentMasterData implements IEquipmentMasterDataWithBomWarningCount {
    private readonly _localizer: (id: string) => string

    constructor(localizer: (id: string) => string, device: IEquipmentMasterDataWithBomWarningCount) {
        super(device.equipment)
        this._localizer = localizer

        this.equipment = device.equipment
        this.docCount = device.docCount

        this.countryCode = device.equipment.soldTo?.countryCode ?? ''
        this.productionOrderNo = device.equipment.productionOrderNo

        this.productionOrderReleasedBySales = device.productionOrderReleasedBySales
        this.productionOrderReleased = device.productionOrderReleased
        this.productionOrderCompleted = device.productionOrderCompleted
        this.productionOrderDeliveredToStock = device.productionOrderDeliveredToStock
        this.equipmentBomHasBeenCrated = device.equipmentBomHasBeenCrated
        this.bomWarningCount = device.bomWarningCount
    }

    readonly equipment: IEquipmentMasterDataDTO
    readonly docCount: number
    readonly countryCode: string
    readonly productionOrderNo?: number
    readonly productionOrderReleasedBySales: boolean
    readonly productionOrderReleased: boolean
    readonly productionOrderCompleted: boolean
    readonly productionOrderDeliveredToStock: boolean
    readonly equipmentBomHasBeenCrated: boolean
    readonly bomWarningCount: number | null

    get status(): string {
        if (this.productionOrderCompleted) {
            return this._localizer('productionCompleted')
        }

        if (this.productionOrderDeliveredToStock) {
            return this._localizer('productionDeliveredToStock')
        }

        if (this.productionOrderReleased) {
            return this._localizer('productionStarted')
        }

        if (this.productionOrderReleasedBySales) {
            return this._localizer('releasedBySales')
        }

        return this._localizer('blockedBySales')
    }
}
